import { FinancialProjectionExtract } from "../shared/FinancialProjectionExtract";
import { IProfitTypeDTO } from "@hooks/dtos/profit/IProfitTypeDTO";
import { useProfitPreview } from "@hooks/functions/Raffle/useProfitPreview";

interface IProps {
  profit: IProfitTypeDTO;
  ticketAmount: number;
  ticketPrice: number;
  rewardPrice: number;
  paymentMethod?: number;
}

export function RaffleProfitPartnerOverview({
  profit,
  ticketAmount,
  ticketPrice,
  rewardPrice,
  paymentMethod = 1,
}: IProps) {
  const preview = useProfitPreview({
    profitId: profit?.id,
    paymentMethod,
    ticketAmount,
    ticketPrice,
  });

  return (
    <FinancialProjectionExtract
      ticketAmount={ticketAmount}
      ticketPrice={ticketPrice}
      rewardPrice={rewardPrice}
      preview={preview.data}
      isLoading={preview.isLoading}
      error={preview.error}
      showGrossRevenue
    />
  );
}